module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (232).a56a6f43.jpg";